import React from 'react';
import { LoadingAnimation } from 'components/loading';
import { DataTable } from 'damco-components';
import { formatDate, formatValueIfNullOrUndefined } from 'utilities/util';
import { status_text } from 'components/exception-management/constants';
import { GeneralCols } from 'views/job-costing/search/models';
import Tooltip from '../../../components/tooltip';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { saveSelectedRows, updateSelectedRows, resetSelectedRows } from 'actions/download-selections';
import { IStore } from 'reducers/index';
import { connect } from 'react-redux';

interface ITableOwnProps {
    data: any[];
    cols?: any[];
    isLoading: boolean;
    pageCount: number;
    pageSize?: number;
    fetchData: any;
    linkAction?: any;
    id: string;
    refFwd?: any;
    isFeatureEnabled?: boolean;
    hasUAMPermission?: boolean;
    actionCallback?: (e: any) => void;
    clickEventHandler?: (e: any) => void;
}

interface IMapStateToProps {
    selectedRowData: any;
}

interface IMapDispatchToProps {
    saveSelectedRows: (data: any) => void;
    updateSelectedRows: (data: any) => void;
    resetSelectedRows: () => void;
}

interface ITableOwnProps extends IMapStateToProps, IMapDispatchToProps { }

interface IState {
    data: any[];
}

export class _GeneralTable extends React.Component<ITableOwnProps, IState> {
    public state = {
        data: []
    };

    public dataTable: any = React.createRef();

    constructor(props: any) {
        super(props);
    }

    public componentDidMount() {
        if (this.props.refFwd && this.props.refFwd.current) {
            this.props.refFwd.current.addEventListener('click', this.clickEventHandler2);
        }
    }

    public componentDidUpdate(props: ITableOwnProps, state: IState) {
        if (this.dataTable.current && (this.props.id === 'jobCosting-search-ets' || this.props.id === 'jobCosting-search-exportJob')) {
            // check if this is the page is undefined or not
            const page = this.dataTable.current.state.page ? this.dataTable.current.state.page : 0;

            // check if this.props.selectedRowData has this page
            const currentRowData = this.props.selectedRowData && this.props.selectedRowData.length ? this.props.selectedRowData.filter((item: any) => item.selectedPage === page) : [];

            if (currentRowData && currentRowData.length) {
                this.dataTable.current.state.selected = currentRowData[0].selectedRows;
                this.dataTable.current.state.selectAll = currentRowData[0].headerChecked ? 1 : 0;
                const count = this.getAllSelectedRows(this.props.selectedRowData).length;
                const span = document.querySelector('.selected-count');
                const cancelButtonContainer = document?.querySelector('.context-right');
                const cancelButton = cancelButtonContainer?.querySelector('button');
                if (cancelButton) {

                    cancelButton.addEventListener('click', () => {
                        const tableRows = document.querySelectorAll('.rt-tbody .rt-tr-group');
                        tableRows.forEach(row => {
                            if (row.classList.contains('-selected')) {
                                row.classList.remove('-selected');
                            }
                        });
                        this.dataTable.current.state.selected = [];
                        this.dataTable.current.state.selectAll = 0;
                        this.props.updateSelectedRows({
                            selectedPage: page,
                            headerChecked: false,
                            selectedRows: [],
                        });
                    });
                }
                if (span) {
                    span.textContent = `${count} selected`;
                }
            } else {
                this.dataTable.current.state.selected = [];
                this.dataTable.current.state.selectAll = 0;
            }
        }

        if (props.data !== this.props.data) {
            const getHmtl = (status: string) => <span dangerouslySetInnerHTML={{ __html: `${status_text.negative} ${status}` }} />;
            const getHmtlNew = (status: string) => <><Tooltip content={status} direction="left"><span dangerouslySetInnerHTML={{ __html: `${this.getTooltp(status)}` }} /></Tooltip></>;
            const data = this.props.data && this.props.data.length ? this.props.data.map((searchItem: any) => {
                searchItem.finOpsStatus = searchItem.finOpsStatus && searchItem.finOpsStatus.props ? searchItem.finOpsStatus : searchItem.rateErrorMessage ? getHmtl(searchItem.finOpsStatus) : searchItem.finOpsStatus;
                searchItem.etd = formatDate(searchItem.etd, 'YYYY-MM-DD');
                searchItem.eta = formatDate(searchItem.eta, 'YYYY-MM-DD');
                searchItem.sealNumber1 = formatValueIfNullOrUndefined(searchItem.sealNumber1);
                searchItem.lastChangedBy = formatValueIfNullOrUndefined(searchItem.lastChangedBy);
                searchItem.createDate = formatDate(searchItem.createDate, 'YYYY-MM-DD HH:mm:ss');
                searchItem.updateDate = formatDate(searchItem.updateDate, 'YYYY-MM-DD HH:mm:ss');
                searchItem.lastChangeDate = formatDate(searchItem.lastChangeDate, 'YYYY-MM-DD HH:mm:ss');
                if (this.props.id === 'jobCosting-search-exportJob') {
                    searchItem.exportJobStatus = searchItem.exportJobStatus && searchItem.exportJobStatus.props ? searchItem.exportJobStatus : searchItem.rateErrorMessage ? getHmtl(searchItem.exportJobStatus) : searchItem.exportJobStatus;
                    searchItem.estimatedTimeOfDeparture = formatDate(searchItem.estimatedTimeOfDeparture, 'YYYY-MM-DD');
                    searchItem.estimatedTimeOfArrival = formatDate(searchItem.estimatedTimeOfArrival, 'YYYY-MM-DD');
                    searchItem.rateErrorMessage = searchItem.rateErrorMessage ? getHmtlNew(searchItem.rateErrorMessage) : searchItem.rateErrorMessage;
                }
                if (this.props.id === 'jobCosting-search-ets') {
                    searchItem.rateErrorMessage = searchItem.rateErrorMessage ? getHmtlNew(searchItem.rateErrorMessage) : searchItem.rateErrorMessage;
                }
                return searchItem;
            }) : [];
            this.setState({ data: Object.assign([], data) });
        }

        if (props.pageSize !== this.props.pageSize) {
            if (this.props.refFwd && this.props.refFwd.current && this.props.refFwd.current.querySelector('select')) {
                this.props.refFwd.current.querySelector('select').value = this.props.pageSize;
            }
        }

        if (this.props.refFwd && this.props.refFwd.current && this.props.refFwd.current.querySelector('.pagination-bottom .-pagination .-next')) {
            const htmlEl = this.props.refFwd.current.querySelector('.pagination-bottom .-pagination .-next button');
            htmlEl.addEventListener('click', this.props.clickEventHandler);
        }

        if (this.props.refFwd && this.props.refFwd.current && this.props.refFwd.current.querySelector('.pagination-bottom .-pagination .-next')) {
            const htmlEl = this.props.refFwd.current.querySelector('.pagination-bottom .-pagination .-previous button');
            htmlEl.addEventListener('click', this.props.clickEventHandler);
        }
    }

    public componentWillUnmount = () => {
        localStorage.setItem('pageSize-ListTable', '10');
        this.props.resetSelectedRows();
    };

    public clickEventHandler2 = (ev: any) => {
        if (
            ev.target.matches('input.checkbox.grid-checkbox') &&
            ev.target.parentNode.matches('div.rt-resizable-header-content') &&
            (this.props.id === 'jobCosting-search-ets' || this.props.id === 'jobCosting-search-exportJob')
        ) {
            this.dataTable.current.toggleSelectAll();
            const page = this.dataTable.current.state.page ? this.dataTable.current.state.page : 0;
            if (this.dataTable.current.state.selectAll === 1) {
                this.props.saveSelectedRows({
                    selectedPage: page,
                    headerChecked: this.dataTable.current.state.selectAll === 1 ? true : false,
                    selectedRows: this.dataTable.current.state.selected,
                });
            } else {
                this.props.updateSelectedRows({
                    selectedPage: page,
                    headerChecked: false,
                    selectedRows: [],
                });
            }
        }
        if (ev.target.matches('input.checkbox.grid-checkbox') && this.props.id === 'extra-document-creation') {
            this.selectedList();
        }
    };

    public getTooltp = (status: any) => {
        return `<span className="example-emoji" role="img" aria-label="duck emoji">
          ${status.substring(0, 12) + '...'}
        </span>`;
    };

    public getActions = (): any[] => {
        const btnList = [
            { isMoreBtn: false, label: 'Download to file', action: () => this.props.actionCallback && this.props.actionCallback(this.getAllSelectedRows(this.props.selectedRowData)) },
        ];
        return btnList;
    };

    public getActionsExtra = (): any[] => {
        const btnList = [
            { isMoreBtn: false, label: 'Create Extra Export', action: () => this.props.actionCallback && this.props.actionCallback(this.dataTable.current.getSelectedItems()) },
        ];
        return btnList;
    };

    public selectedList = () => {
        setTimeout(() => {
            if (this.props.actionCallback) {
                this.props.actionCallback(this.dataTable.current.getSelectedItems());
            }
        }, 10);
    };

    public getSelectable = (): any => {
        if (this.props.id === 'jobCosting-search-ets' || this.props.id === 'jobCosting-search-exportJob') {
            if (this.props.isFeatureEnabled && this.props.hasUAMPermission) {
                return true;
            }
        } else if (this.props.id === 'extra-document-creation') {
            return true;
        }
        else { return false; }
    };

    public fetchRowData = (data: any) => {
        if (this.props.fetchData) {
            this.props.fetchData(data);
        }
        if (this.dataTable.current) {
            this.dataTable.current.state.selectAll = 0;
        }
    };

    public getAllSelectedRows = (data: any) => {
        return data.reduce((acc: any, item: any) => acc.concat(item.selectedRows), []);
    };

    public render() {
        return (
            <React.Fragment>
                <div id={this.props.id} ref={this.props.refFwd}>
                    {this.props.isLoading && <LoadingAnimation smallLoad={true} />}
                    <DataTable
                        data={this.state.data}
                        expandable={false}
                        withCheckboxes={true}
                        columns={this.props.cols ? this.props.cols : GeneralCols}
                        linkAction={this.props.linkAction}
                        ref={this.dataTable}
                        tableName={`ListTable ${this.props.id}`}
                        isSortable={true}
                        pageCount={this.props.pageCount}
                        manualPagination={true}
                        fetchData={(data: any) => this.fetchRowData(data)}
                        showPagination={this.state.data.length > 0}
                        showColumnOptions={true}
                        selectedOption={this.props.id === 'jobCosting-search-ets' || this.props.id === 'jobCosting-search-exportJob' || this.props.id === 'extra-document-creation' ? 'multiple' : 'single'}
                        isSelectable={this.getSelectable()}
                        actions={this.props.id === 'jobCosting-search-ets' || this.props.id === 'jobCosting-search-exportJob' ? {
                            secondaryActions: [],
                            parentContextualActions: this.getActions()
                        } : this.props.id === 'extra-document-creation' ? {
                            secondaryActions: [],
                            parentContextualActions: this.getActionsExtra()
                        } : null}
                    /></div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state: IStore): IMapStateToProps => ({
    selectedRowData: state.downloadSelections.selectedRowData,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, Action>): IMapDispatchToProps => ({
    saveSelectedRows: (data: any) => dispatch(saveSelectedRows(data)),
    updateSelectedRows: (data: any) => dispatch(updateSelectedRows(data)),
    resetSelectedRows: () => dispatch(resetSelectedRows()),
});

export const GeneralTable = connect<IMapStateToProps, IMapDispatchToProps, {}, IStore>(mapStateToProps, mapDispatchToProps)(_GeneralTable);